import { callDecimal } from "../utils.ts";
import {
  CourseUserRole,
  InstitutionProgram,
  MaterialFormat,
  RequiredCode,
} from "./course.ts";

export interface Term {
  active: boolean;
  // e.g. "2040-12-31"
  endOn: string;
  id: string;
  institutionProgram: InstitutionProgram;
  name: string;
  // e.g. "2025-08-01T23:59:59-04:00"
  optOutDeadline: string;
  programDecision: InstitutionProgram;
}

export interface Department {
  id: string;
  name: string;
}

export interface Course {
  id: string;
  name: string;
}

export interface Section {
  active: boolean;
  courseName: string;
  crn: unknown;
  departmentName: string;
  id: string;
  instructor: string;
  name: string;
  notes: string | null;
  posId: unknown;
  userRole: CourseUserRole;
}

export interface Material {
  author: string;
  contentDeliveryControls: unknown;
  contentType: MaterialFormat;
  coverImageUrl: string;
  // e.g. "USD"
  currency: string;
  epos: boolean;
  fileAttachments: unknown[];
  // May be empty string
  id: string;
  isbn: string;
  licenses: unknown[];
  models: unknown[];
  optOut: boolean;
  // e.g. "2025-08-01T23:59:59-04:00"
  optOutEndOn: string;
  optOutEnded: boolean;
  required: RequiredCode;
  requiredStatus: boolean;
  requiresAccessCode: boolean;
  section: Section;
  sku: string | null;
  studentMessage: unknown;
  // e.g. "43.59"
  studentPrice: string | null;
  title: string;
  vbid: string | null;
}

export function getTerms() {
  return callDecimal<Term[]>("/api/v1/verba_core/terms");
}

export function getDepartments(termId: string) {
  return callDecimal<Department[]>(
    `/api/v1/verba_core/terms/${termId}/departments`
  );
}

export function getCourses(termId: string, departmentId: string) {
  return callDecimal<Course[]>(
    `/api/v1/verba_core/terms/${termId}/departments/${departmentId}/courses`
  );
}

export function getSections(
  termId: string,
  departmentId: string,
  courseId: string
) {
  return callDecimal<Section[]>(
    `/api/v1/verba_core/terms/${termId}/departments/${departmentId}/courses/${courseId}/sections`
  );
}

export function getMaterials(termId: string, sectionId: string) {
  return callDecimal<Material[]>(
    `/api/v1/verba_core/terms/${termId}/materials?section_id=${sectionId}`
  );
}
